import React from 'react';
import CalendarRange from '../../../assets/icons/trvto_calendar.svg';
import CalendarCheck2 from '../../../assets/icons/trvto_calendar.svg';
import UsersRound from '../../../assets/icons/trvto_userCount.svg';
import ArrowUp from '../../../assets/icons/dropdownArrowUp.svg';
import ArrowDown from '../../../assets/icons/dropdownArrowDown.svg';

import './bookingStats.css';

const BookingStats = ({ stats }) => {
    const {
        todayBookings = 0,
        todayChange = 0,
        weekBookings = 0,
        weekChange = 0,
        monthBookings = 0,
        monthChange = 0,
        totalBookings = 0
    } = stats || {};

    const getChangeClass = (value) => {
        if (value > 0) return 'stat-change-up';
        if (value < 0) return 'stat-change-down';
        return 'stat-change-neutral';
    };

    const ChangeIndicator = ({ value, text }) => {
        return (
            <div className={`stat-change ${getChangeClass(value)}`}>
                <div className='statsCal'>
                    {value > 0 ? (
                        <img src={ArrowUp} className='statsArrow' alt='increase' />
                    ) : value < 0 ? (
                        <img src={ArrowDown} className='statsArrow' alt='decrease' />
                    ) : (
                        <img src={ArrowUp} className='statsArroe' alt='no change' />
                    )}

                    <span className='change-value'>
                        {value > 0 ? '+' : ''}
                        {value}%
                    </span>
                </div>
                <span className='change-text'>{text}</span>
            </div>
        );
    };

    return (
        <div className='booking-stats-container'>
            {/* TODAY */}
            <div className='booking-stat-card today-card'>
                <div className='stat-icon-wrapper today-icon'>
                    <img src={CalendarRange} className='statsIcon' alt='calendar' />
                </div>

                <div className='stat-content'>
                    <div className='stat-number'>{todayBookings.toLocaleString()}</div>

                    <div className='stat-title'>Today's Bookings</div>

                    <ChangeIndicator value={todayChange} text='vs yesterday' />
                </div>
            </div>

            {/* WEEK */}
            <div className='booking-stat-card week-card'>
                <div className='stat-icon-wrapper week-icon'>
                    <img src={CalendarRange} className='statsIcon' alt='calendar' />
                </div>

                <div className='stat-content'>
                    <div className='stat-number'>{weekBookings.toLocaleString()}</div>

                    <div className='stat-title'>This Week's Bookings</div>

                    <ChangeIndicator value={weekChange} text='vs last week' />
                </div>
            </div>

            {/* MONTH */}
            <div className='booking-stat-card month-card'>
                <div className='stat-icon-wrapper month-icon'>
                    <img src={CalendarCheck2} className='statsIcon' alt='calendar' />
                </div>

                <div className='stat-content'>
                    <div className='stat-number'>{monthBookings.toLocaleString()}</div>

                    <div className='stat-title'>This Month's Bookings</div>

                    <ChangeIndicator value={monthChange} text='vs last month' />
                </div>
            </div>

            {/* TOTAL */}
            <div className='booking-stat-card total-card'>
                <div className='stat-icon-wrapper total-icon'>
                    <img src={UsersRound} className='statsIcon' alt='users' />
                </div>

                <div className='stat-content'>
                    <div className='stat-number'>{totalBookings.toLocaleString()}</div>

                    <div className='stat-title'>Total Bookings</div>

                    <div className='stat-all-time'>All time</div>
                </div>
            </div>
        </div>
    );
};

export default BookingStats;
